import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import Constants from "../../Action/Constants";

class PaymentUpdateWillMount extends Middleware implements MiddlewareInterface {

  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    const id = parseInt(this.component.props.params.id, 10);

    this.component.props.dispatch({
      type: Constants.GLOBAL_PAYMENT_UPDATE_CLEAR
    });

    this.component.initializePage(id);
  }
}

export default new PaymentUpdateWillMount();
